<template>
    <!-- modal login -->
    <v-dialog v-model="dialoglogin" persistent max-width="930px">
        <v-btn color="blue darken-1" class="bot-exit" text @click="dialoglogin = false, EsqueciSenha = false">
            <v-img src="@/assets/iconexit.png" title="Sair" />
        </v-btn>
        <v-card>
                <div class="form login-box">
                <v-card class="login">
                    <div class="form">
                        <v-form ref="form" v-model="valid" lazy-validation v-show="!EsqueciSenha">
                            <div class="titulo-cadastro logi-t">
                                <h1>Login</h1>             
                            </div>
                            <v-col cols="12">
                                <v-text-field v-on:keyup="validInput()"
                                            solo
                                            outlined
                                            v-model="email"
                                            :rules="emailRules"
                                            label="E-mail"
                                            prepend-inner-icon="mdi-email"
                                            required></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-on:keyup="validInput()"
                                            solo
                                            outlined
                                            v-model="senha"
                                            :rules="senhaRules"
                                            :type="'password'"
                                            label="Senha"
                                            prepend-inner-icon="mdi-lock"
                                            required></v-text-field>
                            </v-col>

                            <div class="box-botoes-login">
                                <v-col cols="6" class="p-0 box-entrar">
                                    <v-btn rounded
                                        :disabled="!valid"
                                        class="primary--text bot-2"
                                        @click="validate"
                                        block>Entrar</v-btn>
                                </v-col>
                                <v-col cols="6" class="p-0 box-entrar">
                                    <v-btn rounded v-on:click="toggle" v-show="!btnEsqueciSenhaVoltar" class="primary--text bot-1" block text dark>Esqueci a Senha</v-btn>
                                </v-col>
                            </div>

                            <!-- <v-col cols="12">
                                <v-btn block text color="secondary" dark>Esqueci a Senha</v-btn>
                            </v-col>-->
                            <v-snackbar rounded="pill" :color="snackbarColor" v-model="snackbar" :timeout="timeout">
                                {{ snackbarText }}
                                <template v-slot:action="{ attrs }">
                                    <v-btn icon color="white" text v-bind="attrs" @click="snackbar = false">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                            </v-snackbar>
                            <v-dialog v-model="dialog" width="500">
                                <v-card>
                                    <v-card-title class="headline">Acesso expirado</v-card-title>
                                    <v-card-text>Deseja renovar o seu acesso?</v-card-text>
                                    <v-divider></v-divider>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn rounded color="primary" text @click="dialog = false">Não</v-btn>
                                        <v-btn rounded class="font-weight-black" color="primary" @click="dialog = false; solicitarRenovacao()">Sim, eu quero</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-form>
                        <!-- ESQUECI A SENHA -->
                        <v-form ref="form" v-model="valid" lazy-validation v-show="EsqueciSenha">
                            <div class="titulo-cadastro logi-t">
                                <h1>Esqueci a senha</h1>             
                            </div>
                            <v-col cols="12">
                            <v-text-field v-on:keyup="validInput()"
                                class="input-esqueci-senha"
                                solo
                                outlined
                                v-model="email"
                                :rules="emailRules"
                                label="E-mail"
                                prepend-inner-icon="mdi-email"
                                required
                            ></v-text-field>
                            </v-col>
                            
                            <div class="box-botoes-login">
                                <v-col cols="6">
                                    <v-btn rounded :disabled="!valid" 
                                    color="success" 
                                    class="mr-4 bot-esqueci" 
                                    @click="validarEsqueciSenha" block>Enviar</v-btn>
                                </v-col>
                                <v-col cols="6">
                                    <v-btn rounded 
                                    v-on:click="toggle"
                                    class="primary--text bot-voltar oiu hidden" 
                                    text dark>Voltar</v-btn>
                                </v-col>
                            </div>
                            <v-snackbar rounded="pill" :color="snackbarColor" v-model="snackbar" :timeout="timeout">
                                <span v-html="snackbarText" style="color: white;"></span>   
                                <template v-slot:action="{ attrs }">
                                    <v-btn icon color="white" text v-bind="attrs" @click="snackbar = false">
                                        <v-icon @click="BaixarDoc()">mdi-file</v-icon>                      
                                    </v-btn>
                                </template>
                            </v-snackbar>
                            <v-snackbar rounded="pill" :color="snackbarColor" v-model="snackbarClient" :timeout="timeout">
                                <span v-html="snackbarText" style="color: white;"></span>           
                            </v-snackbar>
                        </v-form>
                    </div>
                </v-card>
                </div>
        </v-card>
    </v-dialog>
</template>
<script>
    import { generateTokenAPI, http } from "../services/APIservice";
    import $ from 'jquery';
    
    $('button.bot-exit').fadeIn(); 

    export default {
        name: "Login",
        props: {
            dialoglogin: {
                type: Boolean,
                default: false
            }
        },
        components: {
            //EsqueciSenha
        },
        watch: {
            dialoglogin(newVal) {
                this.$emit('update:dialoglogin', newVal);
            }
        },
        data: () => ({
            dialog: false,
            snackbar: false,
            snackbarText: "",
            snackbarColor: "info",
            timeout: 50000,
            valid: true,
            senha: "",
            senhaRules: [
                v => !!v || "Digite sua senha",
                v => (v && v.length >= 4) || "A senha deve conter 4 ou mais caracteres."
            ],
            email: "",
            emailRules: [
                v => !!v || "Digite seu e-mail.",
                v => /.+@.+/.test(v) || "Digite um e-mail válido."
            ],
            dialoglogin:false,
            EsqueciSenha: false
        }),
        methods: {
            fecharModal() {
                this.$emit('update:dialoglogin', false);
            },
            toggle(){
                if (!this.EsqueciSenha) {
                    this.EsqueciSenha = true;
                } else {
                    this.EsqueciSenha = false;
                }
            },
            validate() {
                // Garante que o DOM está atualizado antes de acessar o $refs.form
                this.$nextTick(() => {
                    // Verifica se o form existe após o update do DOM
                    if (this.$refs.form) {
                        // Realiza a validação
                        let isValid = this.$refs.form.validate();
                        
                        // Exibe um alerta se a validação falhar
                        if (!isValid) {
                            this.setSnackbar("Preencha todos os campos corretamente.", "error");
                            return;
                        }
                        
                        // Se passou na validação, continua para o login
                        this.valid = false;
                        this.login();
                    } else {
                        // Caso o form não exista, loga um erro para verificar
                        console.error("Form não encontrado após o nextTick.");
                    }
                });
            },
            login() {
                return http
                    .post("User/Login", { email: this.email, password: this.senha }, {
        'Access-Control-Allow-Headers': '*'})
                    .then(response => {
                        if (response.status == 200) {
                            localStorage.setItem("user", JSON.stringify(response.data));
                            this.$router.push("catalogo");
                            this.gerarTokenFlip();
                        }
                        if (response.status == 418) {
                            this.setSnackbar("Seu acesso não possui um convite para fazer degustação, favor entrar em contato com o seu consultor!", "error")
                        }
                        if (response.status == 205) {
                            this.setSnackbar("Uhuulll agora você pode fazer o cadastro e ter mais 30 dias de acesso!", "primary")                            
                        }
                        if (response.status == 206) {
                            this.setSnackbar("Uhuulll agora você pode fazer o cadastro e ter mais 30 dias de acesso!", "primary")
                        }
                        if (response.status == 208) {
                            this.setSnackbar("Cadastro Realizado com Sucesso!", "primary")
                        }
                    })
                    .catch(error => {
                        let status = error.response.status;
                        console.log(error.response.status);
                        //alert(error.response.data.statusDescription);

                        if (status == 401) {
                            this.setSnackbar("E-mail ou senha incorretos", "error")
                        }
                        if (status == 402) {
                            this.setSnackbar("Login não existe em nossa base de dados!", "error")
                        }
                        if (status == 403) {
                            this.setSnackbar("E-mail ou senha incorretos! Confira se os dados foram digitados corretamente e tente novamente.", "error")
                        }
                        if (status == 418) {
                            this.setSnackbar("Seu acesso não possui um convite para fazer degustação, favor entrar em contato com o seu consultor!", "error")
                        }
                        if (status == 406) {
                            this.setSnackbar("Você não possui acesso a essa plataforma", "error")
                        }
                        if (status == 417) {
                            this.dialog = true;
                        }
                        if (status == 500) {
                            this.setSnackbar("A plataforma está com instabilidade :(", "error")
                            //alert("A plataforma está com instabilidade :(");
                        }
                    });
            },
            gerarTokenFlip() {
                return generateTokenAPI
                    .post("GenerateToken", { email: this.email, password: this.senha }, {})
                    .then(response => {
                        if (response.status == 200) {
                            localStorage.setItem("GT", JSON.stringify(response.data));
                        }
                        //console.log(response.data);
                    })
                    .catch(error => {
                        console.log(error.response.status);
                        //alert(error.response.data.statusDescription);
                    });
            },
            solicitarRenovacao() {
                return http
                    .post("User/RequestAcess", { email: this.email }, {})
                    .then(response => {
                        if (response.status == 200) {

                            this.setSnackbar("Aguarde a confirmação do divulgador.", "primary")
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.setSnackbar("Você já solicitou a sua renovação de acesso. Aguarde a confirmação do divulgador.", "primary")
                    });
            },
            validInput() {
                if (this.$refs.form.validate() == true) {
                    this.valid = true;
                }
            },
            validarEsqueciSenha() {
      if(!this.$refs.form.validate()){ return; }
      this.valid = false;

      if(this.email.includes('@editoradobrasil.com.br')){
        var contaAd = this.email.substring(0, this.email.lastIndexOf("@"));
          http.post("/EsqueciSenha/EsqueciSenhaContaAD/", {'ContaAd':  contaAd}, { headers: {'Content-Type': 'application/json'}}, {})
          .then(response => {
          this.valid = true;
          if(response.data.adValido == true){
            window.open("https://passwordreset.microsoftonline.com/?ru=https%3a%2f%2flogin.microsoftonline.com%2f45ba725f-d260-45c3-ac85-11f433471277%2freprocess%3fctx%3drQQIARAAhZC9axNhAIfvzaU1BrVBENwMGhfr5T7e9-5ygUJr01iFEEGbhCzh_bqPmLv3vLsEms3NRRDBxck6SaciWEQcnDtlFDcX0QyiXdrR9C9w-Q0Pv-V5bslGVatXdIeRmkWhQgziKAhRqhAIHQVaDBsQYki4kVwulvb8H_6V-bvG88_tydPZ3sk-KPtZFqd1VQ1308CLgiithgFNRCrcrEpFqH4EYAbATwBe5q7jiCW8mgajCV7nLMhEgpkgCV6Qs2-VJN9yK-2NceYbZyOSYMqPcwU3wV7Io-y1XKnp1NVdjBRCLV1B0GQK1hxDsSlFFocM1UztvVxBJsG2YboKMyxNQebCDNOaqei6iyBEtm7Y9pF8Q8Q8Clg5ToQbjHiZhzgYlYXrjoKIDzClPE2_ymCWB_P8BU2uFwrFknRVKkunefB2aZEjVm8Wv3f_rh_Cpj7LBtLRknqnNzbphHcm0dRq9sKphp2tdDgeei3WURv-k5rJ-wv90Sa9t2bW9RfL4M8yeHZO-nT-2n9K7hdXTb7zQG8TygaRETVisjO-S5rT1q4TCzwWDQvx2PMGnf7j-_SgCL5clE4v_Tp-c_jh5NXv7fnKbeIPNVW0vMB_mKje6lCfdNnWNsKbj9hG5G30-l2atKjd9rpo7aAk_QM1&mkt=pt-BR&hosted=0&device_platform=Windows+10", "_blank")
          } else {            
            this.setSnackbar(response.data.mensagem, "primary");
          }
      })
      .catch(error => {
          console.log(error.response);
          alert('Error');
      })
      }else{      
        http.post("/EsqueciSenha/EsqueciSenha/", {"Email": this.email}, {})
      .then(response => {
          this.valid = true;
          this.setSnackbar(response.data.mensagem, "primary");
      })
      .catch(error => {
          console.log(error.response);
      })
      }
    },
            setSnackbar(texto, cor) {
                this.snackbarText = texto;
                this.snackbarColor = cor;
                this.snackbar = true;
            }
        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
